<script lang="ts">
  import Plus from "~icons/ph/plus-bold"
  import Done from "./Done.svelte";
  let {done=false} = $props()
</script>
<button class={`btn btn-sm btn-circle btn-secondary transition duration-150 ease-in-out ${done ? "w-auto gap-1 overflow-clip" : ""}`}>
  <Plus class={`w-6 h-6 box-content ${done ? "pl-1" : ""}`} />
  {#if done}<Done />{/if}
</button>